export const schema = $axios => ({
  update: () => $axios.$patch('/builder/schema'),
});
